import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import { useDeletedVersionsColumns } from '../hooks/useDeletedVersionsColumns';
import { logService } from '../api/log.service';

export const DeletedVersionsPage = () => {
  const translationPrefix = 'pages.versions.deleted';
  const { t } = useTranslation();
  const columns: GridColDef[] = useDeletedVersionsColumns();

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <EnhancedDataGrid
        columns={columns}
        service={logService}
        refresh={null}
        disableDelete
        outerParams={{ action: 2 }}
      />
    </TenantPage>
  );
};

export default DeletedVersionsPage;
